// src/components/Common/Particles.js

import React from "react";

const Particles = ({ count = 40 }) => {
  const particles = Array.from({ length: count });

  return (
    <>
      {particles.map((_, i) => (
        <div
          key={i}
          className="particle"
          style={{
            left: `${Math.random() * 100}vw`,
            animationDuration: `${Math.random() * 15 + 10}s`,
            top: `${-5 - Math.random() * 100}vh`,
            width: `${Math.random() * 3 + 2}px`,
            height: `${Math.random() * 3 + 2}px`,
            opacity: Math.random() * 0.5 + 0.3, // Vary opacity for realism
          }}
        ></div>
      ))}
    </>
  );
};

export default Particles;
